import DiscoveryPageContainer from './container';

export default DiscoveryPageContainer;



// WEBPACK FOOTER //
// ./app/src/components/Discovery/index.jsx